import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../../formWrapper/SourSearchWrapper';
const tips = {
    order_number: {
        label: 'an order number',
        applications: ['aap', 'wayste', 'customer-portal'],
        entities: [
            'sourgum-order',
            'sourgum-payable',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-order',
            'wayste-payable',
            'wayste-receivable',
        ],
    },
    name: {
        label: 'customer name',
        applications: ['aap', 'wayste'],
        entities: [
            'sourgum-customer',
            'wayste-customer',
            'sourgum-lead',
            'sourgum-order',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-commercial-subscription',
            'wayste-order',
            'wayste-receivable',
        ],
    },
    address: {
        label: 'customer address',
        applications: ['aap', 'wayste', 'customer-portal'],
        entities: [
            'sourgum-customer',
            'wayste-customer',
            'sourgum-lead',
            'sourgum-order',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-commercial-subscription',
            'wayste-order',
        ],
    },
    dumpster: {
        label: 'dumpster name/number',
        applications: ['wayste'],
        entities: ['wayste-dumpster', 'wayste-tagged-container'],
    },
    email: {
        label: 'customer email',
        applications: ['aap', 'wayste'],
        entities: ['sourgum-customer', 'wayste-customer', 'sourgum-lead'],
    },
    phone: {
        label: 'customer phone number',
        applications: ['aap', 'wayste'],
        entities: ['sourgum-customer', 'wayste-customer', 'sourgum-lead'],
    },
    vendor: {
        label: 'partner hauler name',
        applications: ['aap'],
        entities: ['sourgum-order', 'sourgum-payable', 'sourgum-service-grouping'],
    },
    account_number: {
        label: 'customer account number',
        applications: ['aap', 'wayste'],
        entities: [
            'sourgum-customer',
            'wayste-customer',
            'sourgum-order',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-commercial-subscription',
            'wayste-order',
        ],
    },
};
export const SearchTips = () => {
    const { application, defaultFilters } = useContext(CustomFormContext);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "xs:w-[90vw] flex flex-col md:w-[70vw] lg:w-[60vw]", children: [_jsx("div", { className: "p-1", children: _jsx("h2", { className: "text-sourgum-greyblue-500 pb-1 text-sm", children: "SUGGESTED FILTERS" }) }), _jsx("ul", { className: "space-y-1", children: Object.keys(tips).map((key) => {
                            if (application &&
                                tips[key].applications.includes(application) &&
                                (!defaultFilters?.query?.type || tips[key].entities.includes(defaultFilters.query.type))) {
                                return (_jsxs("li", { className: "p-1 text-sm", children: [_jsxs("span", { className: "p bg-sourgum-greyblue-50 rounded p-0.5", children: [key, ":"] }), " ", tips[key].label] }, key));
                            }
                            else {
                                return null;
                            }
                        }) })] }), _jsx("div", { className: "bg-sourgum-greyblue-50 w-full p-1", children: _jsx("h2", { className: "p-0.5 text-sm", children: _jsxs("div", { className: "flex flex-row items-center justify-start space-x-1", children: [_jsx(QuestionMarkCircleIcon, { className: "size-4" }), _jsx("div", { children: "Search tips: Wrap a phrase in quotes, \"phrase\", to search for exact matches." })] }) }) })] }));
};
//# sourceMappingURL=SearchTips.js.map